import { fetchJsonWithRetry } from "./FetchWithRetry";
import { GameList } from "./GameList";
import { redirectUrl } from "./Redirect";
import { initSentry } from "./Sentry";

export type BuildConfiguration = {
    online: {
        staging: number,
        stage1: number,
        stage2: number,
        stage3: number,
        stage4: number,
    },
    onlineSelective: {
        staging: number,
        stage1: number,
        stage2: number,
        stage3: number,
        stage4: number,
    },
    jackpots: {
        staging: string,
        production: string,
    }
}
console.log("index.ts reached")
if (new URL(document.location.href).searchParams.get("addBreakpointAtRedirectsStart")) {
    debugger
}
initSentry();
console.log("Sentry started")

const redirectsConfigUrl = document.location.origin.includes("127.0.0.1") || document.location.origin.includes("localhost") ? document.location.origin + "/dist/redirects_configuration.json" : document.location.origin + "/redirects_configuration.json";

(async () => {
    const buildsConfiguration = await fetchJsonWithRetry<BuildConfiguration>(redirectsConfigUrl);
    const url = new URL(document.location.href);
    document.location.replace(redirectUrl(url, GameList, buildsConfiguration));
})();

